export { HeroDecor } from './HeroDecor.brand.generated';
